import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatModule } from '../appModules/mat.module';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { ExportService } from '../shared/services/exportservice';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-change-of-branch',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatLabel,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule,
  ],
  templateUrl: './change-of-branch.component.html',
  styleUrl: './change-of-branch.component.scss'
})
export class ChangeOfBranchComponent {
  pagination = {
    length: 0,
    page: 1,
    limit: 10,
  };
  course_change_list = new MatTableDataSource<any>();
  currentPage=0;
  searchText: string = '';
  displayedColumns: string[] = [
    'sno','student_name','previous_register_number','current_register_number','previous_course','current_course'
  ];


  constructor(private http: HttpClient, private api: ApiService, private common: CommonService, private exportService: ExportService, private cdr: ChangeDetectorRef) {}
  ngOnInit(){
    this.change_of_course_listAll()
  }

  change_of_course_listAll(search?: string) {
    interface StudentFilterPayload {
      search?: String;
    }
    const payload: StudentFilterPayload = {};
    if (search){
      payload.search = search
    }
    const queryParam = `?page=${this.pagination.page}&limit=${this.pagination.limit}`;
    this.api.post(`students/change_of_branch_list${queryParam}`, payload, true).subscribe({
      next: (resp) => {
        if (resp.status) {
          this.course_change_list = resp.data;
          this.pagination.length = resp?.totalCount || 0;
          this.cdr.detectChanges();
          this.currentPage = (this.pagination.page - 1) * this.pagination.limit;
          console.log('change of branch list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching course change list:', err);
      }
    });
  }

  pageEvent(e: any) {
    this.pagination.page = e.pageIndex + 1;
    this.pagination.limit = e.pageSize;
    this.currentPage = e.pageIndex * e.pageSize;
    this.change_of_course_listAll();
  }
  applyFilter() {
    this.pagination.page = 1;
    this.change_of_course_listAll(this.searchText);
  }

}
